(ns frontend.ui.page.lp-report-editor.step-5-approved.view
  (:require
   [common.localization :as loc]
   [frontend.ui.page.lp-report-editor.common.event :as common-event]
   [frontend.ui.page.lp-report-editor.common.modal.pdf-preview-modal :as pdf-preview-modal]
   [frontend.ui.page.lp-report-editor.common.style :as common-style]
   [frontend.ui.page.lp-report-editor.common.view :refer
    [burn-pdf-button continue-button footer next-button
     preview-pdf-button] :as common-view]
   [frontend.ui.page.lp-report-editor.event :as editor-event]
   [frontend.ui.page.lp-report-editor.step-5-approved.event :as event]
   [frontend.ui.page.lp-report-editor.step-5-approved.sub :as sub]
   [frontend.ui.page.lp-report-editor.sub :as editor-sub]
   [herb.core :refer [<class]]
   [re-frame.core :as rf]
   [ui.components.button.view :as button]))

(defn step-footer
  [selected-report feeder-tab?]
  (let [report @(rf/subscribe [::editor-sub/lp-report])
        feeder-report  (first @(rf/subscribe [::editor-sub/feeder-reports]))
        burned-pdfs (seq (:lp-report/burned-pdfs selected-report))
        materials-only? (= (:lp-report/template-type report) :lp-report-template/materials-only)
        missing-burned-pdf? (if feeder-report
                              (some empty?
                                    [(:lp-report/burned-pdfs report)
                                     (:lp-report/burned-pdfs feeder-report)])
                              (empty? (:lp-report/burned-pdfs report)))
        wip? (or @(rf/subscribe [::editor-sub/reports-not-approved?])
                 @(rf/subscribe [::editor-sub/feeder-not-approved?])
                 (and (not materials-only?) missing-burned-pdf?))
        full-access? @(rf/subscribe [::editor-sub/full-access?])
        burn-processing? @(rf/subscribe [::editor-sub/burn-pdfs-processing?])]
    [footer
     {:left-content
      [:<>
       [continue-button]
       [:div
        [pdf-preview-modal/view
         {:on-close #(rf/dispatch [::common-event/close-pdf-preview])
          :report   selected-report
          :feeder?  feeder-tab?}]
        [preview-pdf-button
         {:on-click #(rf/dispatch [::common-event/open-pdf-preview selected-report feeder-tab?])}]]
       (when-not materials-only?
         [:div
          {:class (<class common-style/spacing-left)}
          (if burn-processing?
            [button/square-primary-solid
             {:on-click identity}
             [:i.fal.fa-spinner.fa-pulse]]
            [burn-pdf-button
             {:on-click #(rf/dispatch [::common-event/burn-pdfs selected-report (:db/id report)
                                       feeder-tab?])}])])
       (when burned-pdfs
         [:div
          [button/primary-solid
           {:on-click #(rf/dispatch [::editor-event/open-burned-pdf burned-pdfs])}
           (loc/tr :open-burned-pdf)]])]
      :right-content
      [:<>
       [:div
        {:class (<class common-style/spacing-left)}
        (cond (not= :lp-report.step/approved (:lp-report/step report))
              [next-button [::editor-event/activate-step :lp-report.step/publishing-queue]]
              full-access?
              [button/secondary-hollow
               {:disabled? wip?
                :tooltip (when wip?
                           (loc/tr :send-to-publishing-queue-tooltip))
                :on-click  #(rf/dispatch [::event/to-publishing-queue (:db/id report)])}
               (loc/tr :send-to-publishing-queue)])]]}]))

(defn approved
  []
  [common-view/report-viewer sub/report-tab-path step-footer])


(defn body
  []
  [approved])
